import InstanceApi from "@/services/apiClient.js";
import { mapActions, mapGetters } from "vuex";
import EventBus from "@/event-bus";

export default {
  computed: {
    ...mapGetters({
      storeId: "getStoreId",
    }),
    ...mapGetters({ storeUrlPrefix: "getStoreUrlPrefix" }),
  },
  methods: {
    ...mapActions(["updateCurrentCartRecaps"]),
    ...mapActions(["setCurrentUserIsLoggedIn", "setCurrentUserIsLoggedIn"]),
    ...mapActions(["setCurrentUser", "setCurrentUser"]),
    ...mapActions(["setDateUpdateSlotDelivery", "setDateUpdateSlotDelivery"]),
    ...mapActions(["setDateFromServer", "setDateFromServer"]),

    async addItemToCart(productId, quantity = 1, needCartCleaning = false) {
      try {
        
        EventBus.$emit('toggleLoader')
        let apiUrlAddOptionToCart = `mcp/cart/add/product/${productId}/qty/${quantity}`;

        if(needCartCleaning){
          apiUrlAddOptionToCart += "/need_cart_cleaning/true";
        }

        const response = await InstanceApi.get(apiUrlAddOptionToCart);
        EventBus.$emit('toggleLoader')
        if (response.status && response.status === 200) {
          this.updateCurrentCartRecaps(response.data);

          if (response.data.customer_logged_in) {
            this.setCurrentUserIsLoggedIn(response.data.customer_logged_in);
            this.setCurrentUser(response.data.customer);
          }

          //Set times slot selected for countdown
          this.setDateUpdateSlotDelivery(response.data.mcp_intervention_date_updated_at);
          this.setDateFromServer(response.headers.date);

        }
      } catch (error) {
        EventBus.$emit('toggleLoader')
        this.$fire({
          title: "Oups",
          text: "Une erreur est survenu lors de la mise à jour de l'option",
          type: "error",
          timer: 1500,
          position: "top-end",
        });
      }
    },
  },
};
